<div
    class="ft-image-div"
    [class.ft-profile-pic]="profilePhoto()"
    [class]="silhouetteClasses()"
    [style.background-image]="backgroundImage()"
    [hidden]="!isVisible()"
></div>
